/**
 * @fileOverview This file contains the implementation of the Toolbar component for Inventory module
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import customAxios from '../../utils/customAxios';
import { GlobalVariables } from '../../globalVar';
//#endregion

const Filter = ({ setFilters }) => {
  const [equipments, setEquipments] = useState([]);

  useEffect(() => {
    const fetchEquipments = async () => {
      try {
        const response = await customAxios.get(
          `${GlobalVariables.getURL()}listEquipments`,
          {
            headers: {
              Authorization: 'bearer ' + localStorage.getItem('token'),
            },
          }
        );
        const equipmentData = response.data.map((equip) => {
          return {
            equipment_id: equip.id,
            ...equip,
          };
        });
        setEquipments(equipmentData);
      } catch (error) {
        console.error('Error fetching equips:', error);
      }
    };

    fetchEquipments();
  }, []);

  return (
    <Autocomplete
      options={equipments}
      getOptionLabel={(equip) => equip.equip_name}
      getOptionSeleted={(equip, value) => equip.id === value.id}
      sx={{ width: '30%', height: '100%' }}
      disableCloseOnSelect
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={'Buscar refacción, categoría, ubicación, etc...'}
          variant="standard"
          className="inventory-toolbar-filter"
        />
      )}
      onChange={(event, newValue, reason) => {
        if (reason === 'clear') {
          setFilters([]);
        } else {
          setFilters({ equipment_id: newValue.id });
        }
      }}
    />
  );
};

export default Filter;
